import * as React from 'react';
import { SVGProps } from 'react';

const IconSettingsSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.255 14c0 .408-.037.792-.086 1.176l2.603 1.98c.234.18.296.504.148.768l-2.467 4.152c-.148.264-.47.372-.753.264l-3.072-1.2a9.544 9.544 0 0 1-2.085 1.176l-.468 3.18a.596.596 0 0 1-.605.504h-4.935a.597.597 0 0 1-.604-.504l-.469-3.18a9.077 9.077 0 0 1-2.085-1.176l-3.072 1.2c-.271.096-.604 0-.752-.264l-2.467-4.152a.594.594 0 0 1 .148-.768l2.603-1.98A9.263 9.263 0 0 1 4.75 14c0-.396.037-.792.087-1.176l-2.603-1.98a.581.581 0 0 1-.148-.768l2.467-4.152c.148-.264.469-.372.752-.264l3.072 1.2a9.545 9.545 0 0 1 2.085-1.176l.469-3.18A.597.597 0 0 1 11.535 2h4.935c.309 0 .568.216.605.504l.468 3.18c.753.3 1.444.696 2.085 1.176l3.072-1.2c.271-.096.605 0 .753.264l2.467 4.152a.594.594 0 0 1-.148.768l-2.603 1.98c.05.384.086.768.086 1.176ZM14 18a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
    />
  </svg>
);
export default IconSettingsSizeL;
